import service from '@/config/axios'

// ==================== 购物车接口 ====================

/**
 * 添加产品到询价购物车
 * @param {Object} model - { ProductID, UserID, CustomisationText }
 */
const addToCart = (model) => {
  return service.post('/api/enquiry/cart/add', model,{ rawResponse: true })
}

/**
 * 获取当前用户的购物车项
 * @param {number} userId - 用户ID
 */
const getCartItems = (userId) => {
  return service.get('/api/enquiry/cart/list', { params: { userId } },{ rawResponse: true })
}

/**
 * 从购物车中移除指定项
 * @param {number} cartId - 购物车项ID
 * @param {number} userId - 用户ID
 */
const removeFromCart = (cartId, userId) => {
  return service.get(`/api/enquiry/cart/remove/${cartId}`, { params: { userId } },{ rawResponse: true })
}

/**
 * 更新购物车项（定制文本）
 * @param {Object} model - { CartID, UserID, CustomisationText }
 */
const updateCartItem = (model) => {
  return service.post('/api/enquiry/cart/update', model,{ rawResponse: true })
}

// ==================== 询价提交与查询 ====================

/**
 * 提交询价
 * @param {Object} model - 询价信息（含UserID、Name、Email、Phone、AdditionalNotes、Products）
 */
const submitEnquiry = (model) => {
  return service.post('/api/enquiry/submit', model,{ rawResponse: true })
}

/**
 * 获取我的询价列表
 * @param {Object} params - { userId, pageIndex, pageSize }
 */
const getMyEnquiries = (params) => {
  return service.get('/api/enquiry/my', { params })
}

/**
 * 获取询价详情
 * @param {number} enquiryId - 询价ID
 */
const getEnquiryDetail = (enquiryId) => {
  return service.get(`/api/enquiry/${enquiryId}`)
}

// ==================== 管理员接口 ====================

/**
 * 管理员获取询价列表
 * @param {Object} params - { status, startDate, endDate, pageIndex, pageSize }
 */
const getAdminEnquiries = (params) => {
  return service.get('/api/enquiry/admin/list', { params })
}

/**
 * 管理员更新询价状态（控制器为 HttpPost，故使用 post）
 * @param {Object} model - { EnquiryID, Status, ResponseNotes }
 */
const updateAdminEnquiryStatus = (model) => {
  return service.post('/api/enquiry/admin/status', model)
}

export {
  addToCart,
  getCartItems,
  removeFromCart,
  updateCartItem,
  submitEnquiry,
  getMyEnquiries,
  getEnquiryDetail,
  getAdminEnquiries,
  updateAdminEnquiryStatus
}